//@flow
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { useThemeMode } from '../contexts/ThemeContext';

const useStyles = makeStyles((theme) => ({
    toggleButton: {
        marginLeft: theme.spacing(1),
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            transform: 'rotate(180deg)',
            background: 'rgba(212, 175, 55, 0.15)',
        },
    },
    icon: {
        color: theme.palette.primary.light,
        filter: 'drop-shadow(0 0 8px rgba(212, 175, 55, 0.4))',
        fontSize: '1.5rem',
    },
}));

export default function ThemeToggle() {
    const classes = useStyles();
    const { mode, toggleMode } = useThemeMode();

    return (
        <Tooltip title={mode === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
            <IconButton
                className={classes.toggleButton}
                onClick={toggleMode}
                aria-label="toggle theme"
            >
                {mode === 'dark' ? (
                    <Brightness7Icon className={classes.icon} />
                ) : (
                    <Brightness4Icon className={classes.icon} />
                )}
            </IconButton>
        </Tooltip>
    );
}
